import React from "react";
import { Flex, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const LoginRequired = ({ 
  title = "Inicia sesión para ver esto", 
  subtitle = "Necesitas estar autenticado para acceder a tu lista de favoritos y carrito." 
}) => {
  const navigate = useNavigate();

  return (
    <Flex 
      vertical
      justify="center" 
      align="center" 
      style={{ 
        minHeight: "70vh", 
        padding: "40px 20px",
        textAlign: "center" 
      }}
    >
      {/* Icon Wrapper Premium */}
      <div style={{
        width: "120px",
        height: "120px",
        background: "#f0fdf4",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "32px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.02)"
      }}>
        <LockOutlined style={{ color: "#1dbf73", fontSize: "48px" }} />
      </div>

      <Title level={3} style={{ 
        marginBottom: "12px", 
        fontWeight: "700",
        color: "#1e293b"
      }}>
        {title}
      </Title>

      <Paragraph style={{ 
        color: "#64748b", 
        fontSize: "16px", 
        maxWidth: "320px", 
        margin: "0 auto 32px",
        lineHeight: "1.6"
      }}>
        {subtitle}
      </Paragraph>

      <Button 
        type="primary" 
        size="large" 
        onClick={() => navigate("/login")}
        style={{ 
          backgroundColor: "#1dbf73", 
          borderColor: "#1dbf73",
          height: "54px",
          padding: "0 48px",
          borderRadius: "14px",
          fontWeight: "600",
          fontSize: "16px",
          boxShadow: "0 10px 20px -10px rgba(29, 191, 115, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        Iniciar sesión
      </Button>
    </Flex>
  );
};

export default LoginRequired;
